import ScalarSearchResultList_vue_vue_type_script_setup_true_lang_default from "./ScalarSearchResultList.vue.script.js";
//#region src/components/ScalarSearchResults/ScalarSearchResultList.vue
var ScalarSearchResultList_default = ScalarSearchResultList_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarSearchResultList_default as default };

//# sourceMappingURL=ScalarSearchResultList.vue.js.map